import {
    getSum,
    updateArrayWithCurrency,
    updateArrayWithCurrencyForSum,
    updateArrayWithToFixed,
} from "shared/helper-functions/table/tableHelpers";
import { useEffect, useState } from "react";

export const useFixedRowsMoney = ({
    initialData = [],
    summary = [],
    currency = [],
    showCurrency = true,
    totalsStrColmAtStart = 1,
    totalColumns = [],
}) => {
    const [totalMoney, setTotalMoney] = useState([...initialData]);
    const [totalOneUpdate, setTotalOneUpdate] = useState(true);

    useEffect(() => {
        if (!summary.isFetching && !currency.isFetching && totalOneUpdate) {
            let moneyArr = [...initialData];            
            const symbol = showCurrency ? currency?.data?.Symbol ?? "" : "";
            // if it's an array else it's an object
            if (summary.data?.length > 0) {
                getSum(
                    totalColumns,
                    totalsStrColmAtStart,
                    summary?.data,
                    moneyArr
                );
                updateArrayWithCurrencyForSum(
                    symbol,
                    totalColumns,
                    moneyArr,
                    totalsStrColmAtStart
                );
            } else {
                updateArrayWithCurrency(
                    symbol,
                    summary?.data,
                    totalColumns,
                    moneyArr,
                    totalsStrColmAtStart
                );
            }
            setTotalOneUpdate(false);
            setTotalMoney(moneyArr);
        }
    }, [summary?.data, summary.isFetching, currency, initialData, showCurrency, totalColumns, totalOneUpdate, totalsStrColmAtStart]);

    return [totalMoney, setTotalOneUpdate];
};

export const useFixedRowsHours = ({
    initialData = [],
    summary = [],
    totalsStrColmAtStart = 1,
    totalColumns = [],
}) => {
    const [totalHours, setTotalHours] = useState([...initialData]);
    const [totalTwoUpdate, setTotalTwoUpdate] = useState(true);

    useEffect(() => {
        if (!summary.isFetching && totalTwoUpdate) {
            let hoursArr = [...initialData];
            getSum(totalColumns, totalsStrColmAtStart, summary?.data, hoursArr);
            updateArrayWithToFixed(
                totalColumns,
                hoursArr,
                totalsStrColmAtStart
            );
            setTotalTwoUpdate(false);
            setTotalHours(hoursArr);
        }
    }, [summary, initialData, totalColumns, totalTwoUpdate, totalsStrColmAtStart]);

    return [totalHours, setTotalTwoUpdate];
};
